import React from 'react'
import { Col, Row } from 'react-bootstrap'
import styles from './countryRow.module.css'
import { Country } from '../../../models/Country'

interface CountryRowProps {
  country: Country
  onSelectRow: (countryId: string) => void
  extraText?: string
}

const CountryRow: React.FC<CountryRowProps> = ({
  country,
  onSelectRow,
  extraText
}) => {
  return (
    <Col lg={8} className="mx-auto">
      <div
        className={`flagItem ${styles.flagItemClickable}`}
        data-testid="countryItem"
        onClick={() => {
          onSelectRow(country.id)
        }}
      >
        <Row className="align-v-center">
          <Col xs={3} sm={2}>
            <img
              src={`/icons/flag-${country.name.toLowerCase()}.svg`}
              alt={`${country.name} flag`}
            />
          </Col>
          <Col xs={9} sm={10}>
            {extraText ? (
              <div>
                {extraText}
                <br />
                <span className="gray-text">{country.name}</span>
              </div>
            ) : (
              <span>{country.name}</span>
            )}
          </Col>
        </Row>
      </div>
    </Col>
  )
}

export default CountryRow
